import { apiClient } from './apiClient';

export const loginApi = (loginData) => apiClient('/auth/login', { body: loginData });
export const logoutApi = () => apiClient('/auth/logout', { method: 'POST' });
export const getMeApi = () => apiClient('/auth/me', { method: 'GET' });
export const forgotPasswordApi = (email) => apiClient('/auth/forgot-password', { body: { email } });
export const resetPasswordApi = (token, newPassword) => apiClient('/auth/reset-password', { body: { token, newPassword } });

export const updateProfileApi = (profileData) => {
  if (profileData instanceof FormData) {
    return apiClient('/auth/profile', { method: 'PUT', body: profileData });
  }

  if (profileData && profileData.profile_image instanceof File) {
    const formData = new FormData();
    formData.append('firstname', profileData.firstname || '');
    formData.append('lastname', profileData.lastname || '');
    formData.append('email', profileData.email || '');
    formData.append('profile_image', profileData.profile_image);
    return apiClient('/auth/profile', { method: 'PUT', body: formData });
  }

  return apiClient('/auth/profile', { method: 'PUT', body: profileData });
};

export const changePasswordApi = (passwordData) => apiClient('/auth/change-password', { method: 'PUT', body: passwordData });
